import { render } from "./conversation.vue?vue&type=template&id=b16c9aaa&scoped=true"
import script from "./conversation.vue?vue&type=script&lang=js"
export * from "./conversation.vue?vue&type=script&lang=js"

import "./conversation.vue?vue&type=style&index=0&id=b16c9aaa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b16c9aaa"]])

export default __exports__